export default function ComingSoon(props){
    return(
        <h1>{props.category} coming soon</h1>
    )
}